import { supabase } from '@/lib/supabase'

export type PushTemplates = {
  titleIndividual: string
  bodyIndividual: string
  titleBatch: string
  bodyBatch: string
}

const K_TITLE_I = 'ops.webpush_tpl_title_individual'
const K_BODY_I = 'ops.webpush_tpl_body_individual'
const K_TITLE_B = 'ops.webpush_tpl_title_batch'
const K_BODY_B = 'ops.webpush_tpl_body_batch'

const DEFAULTS: PushTemplates = {
  titleIndividual: '{moeda} - {tf_label}',
  bodyIndividual: 'Buscando {tendencia}. Aproveite!',
  titleBatch: 'Novas oportunidades',
  bodyBatch: 'Tem {qtd} oportunidades novas. Confira!',
}

export async function getPushTemplates(): Promise<PushTemplates> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('key,value')
    .in('key', [K_TITLE_I, K_BODY_I, K_TITLE_B, K_BODY_B])
  if (error) return DEFAULTS
  const map = new Map<string, string>((data || []).map((r: any) => [String(r.key), String(r.value)]))
  return {
    titleIndividual: map.get(K_TITLE_I) || DEFAULTS.titleIndividual,
    bodyIndividual: map.get(K_BODY_I) || DEFAULTS.bodyIndividual,
    titleBatch: map.get(K_TITLE_B) || DEFAULTS.titleBatch,
    bodyBatch: map.get(K_BODY_B) || DEFAULTS.bodyBatch,
  }
}

export async function setPushTemplates(t: PushTemplates): Promise<void> {
  const rows = [
    { key: K_TITLE_I, value: String(t.titleIndividual || DEFAULTS.titleIndividual) },
    { key: K_BODY_I, value: String(t.bodyIndividual || DEFAULTS.bodyIndividual) },
    { key: K_TITLE_B, value: String(t.titleBatch || DEFAULTS.titleBatch) },
    { key: K_BODY_B, value: String(t.bodyBatch || DEFAULTS.bodyBatch) },
  ]
  const { error } = await supabase.from('app_settings').upsert(rows as any, { onConflict: 'key' })
  if (error) throw error
}

